import type {IAsset} from '@netx/core-asset-next/schema';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	assetPermissionChecker,
	PermissionMatrixName,
	PermissionName,
} from '@netx/core-permissions-next/utils/assetPermissionChecker';
import {assetHasConstituentKeyframes} from '@netx/core-asset-next/enablers';

export const canViewAssetConstituentKeyframes = (asset?: IAsset): boolean => {
	if (!assetHasConstituentKeyframes(asset)) return false;
	if (!currentUserMeetsUserLevel(UserLevel.MANAGER)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.READ,
		permissionName: PermissionName.VIEW,
	});
};
